import type { HTMLAttributes, ReactNode } from 'react'

export interface ButtonGroupProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Children are expected to carry `className="join-item"` themselves (e.g. a
   * row of `<button className="join-item btn ...">` or `<ViewSwitch>`-style
   * options) — ButtonGroup only renders the `.join` wrapper, it does not
   * modify children.
   */
  children: ReactNode
  /** Default 'horizontal'. */
  orientation?: 'horizontal' | 'vertical'
  className?: string
}

// EP-108 P002 — joined-buttons wrapper primitive. Horizontal gets
// overflow-x-auto by default: wrapping join-items breaks the joined-border
// visual, so we scroll instead of wrap (CLAUDE.md scroll-not-wrap
// convention); it's a no-op when the content already fits. Vertical stacks
// via join-vertical and never needs the horizontal scroll behavior.
export function ButtonGroup({ children, orientation = 'horizontal', className = '', ...rest }: ButtonGroupProps) {
  const orientationClass = orientation === 'vertical' ? 'join-vertical' : 'overflow-x-auto'
  return (
    <div className={`join ${orientationClass} ${className}`.replace(/\s+/g, ' ').trim()} {...rest}>
      {children}
    </div>
  )
}
